/**
 * KnockoutData ViewModel and DataGrid ({@link http://selerix.com})
 * @copyright Copyright 2025, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// base viewmodel inherited by custom knockout objects
var ViewModel = function (containerSelector) {
	var self = this;
	self._isValid = function (f) { return !(f === 'Key' || f === 'init' || f === 'extend' || f === 'toJS' || f === 'toJSON' || f.substring(0, 1) === '_'); };
	self._isBound = function () { return $(self.selector).data('bound') === true; };
	self.selector = containerSelector;
	self.bindingSelector = this.selector;
	self.service = {
		url: $(this.selector).data('service-url'),
		methods: {
			search: 'Search',
			add: 'Save',
			update: 'Save',
			remove: 'Delete',
			pager: 'Pager',
			cancel: 'Cancel'
		}
	};
	self.title = $(self.selector).attr('title') || '';
	self.editable = ko.observable(true);
	self.keyProperty = ko.observable();
	self.index = ko.observable(-1);
	self.enabled = ko.observable(true);
	self.summary = $(this.selector).data('summary');
	self.dialog = {
		selector: $(self.selector).data('dialog') ? '#' + $(self.selector).data('dialog') : null,
		settings: function (obj) {
			if (this._settings === void 0) this._settings = {};
			if (obj === void 0) obj = {};
			if (!this.initialized()) {
				if (obj.customID === void 0 && this.selector !== null) obj.customID = this.selector.replace('#', '');
				else if (obj.customID !== void 0 && this.selector === null) this.selector = '#' + obj.customID;
				$.extend(this._settings, obj);
				this.initialized(true);
			}
			return $.extend({},this._settings);
		},
		open: function () {
			createDialog(this.settings());
			this.visible(true);
		},
		close: function () {
			$(this.selector).modal('hide');
			this.visible(false);
		},
		enabled: function() { return this.selector !== null && this.selector !== void 0 },
		focus: function () { $(this.selector).modal('focus'); },
		visible: ko.observable(false),
		initialized: ko.observable(false)
	};
	self.model = {
		// computed Key value for reference. best to define Key property for accuracy
		Key: ko.computed(function () {
			if (this.keyProperty()) {
				return (ko.isObservable(this.model[this.keyProperty()])) ? this.model[this.keyProperty()]() : this.model[this.keyProperty()];
			} else return -1;
		}, self),
		init: function (m) {
			for (var f in self.model) {
				if (!self._isValid(f)) continue;
				try {
					if (ko.isObservable(m[f])) {
						if (ko.isObservable(self.model[f])) self.model[f](m[f]());
						else self.model[f] = m[f]();
					} else {
						if (ko.isObservable(self.model[f])) self.model[f](m[f]);
						else self.model[f] = m[f];
					}
				} catch (ex) { }
			}
			for (var d = 0; d < self.items().length; d++) {
				if (self.items()[d] == m) { self.index(d); break; }
			}
			if (!self.keyProperty()) {
				var key = $(self.selector).data('key');
				if (key) { self.keyProperty(key); }
				else if (self.items().length) {
					for (var p in self.items()[0]) {
						if (p.toLowerCase().endsWith('id')) { self.keyProperty(p); break; }
					}
				}
			}
		},
		extend: function (extended) {
			$.extend(this, extended);
			for (var f in this) {
				if (ko.isObservable(this[f]) && this[f].required === void 0) this[f].required = ko.observable(false);
			}
		},
		toJS: function () {
			var m = ko.toJS(this), o = {};
			for (var p in m) { if (self._isValid(p)) o[p] = m[p]; }
			return o;
		},
		toJSON: function () { return ko.toJSON(this.toJS()); }
	};
	self.events = {
		add: function () {
			if (self.dialog.enabled()) {
				self.events.empty();
				if (self.summary) $(self.summary).validationSummary();
				self.dialog.open();
			}
		},
		edit: function () {
			self.model.init(this);
			if (self.summary) $(self.summary).validationSummary();
			if (self.dialog.enabled()) self.dialog.open();
		},
		update: function (callback) { self.events.save(callback); },
		focusFirst: function (form) {
			var field = null;
			if (form === null || form === void 0) { return; }
			$(form).find('.has-error select, .has-error input, .has-error textarea').each(function () {
				if (field !== null) { return false; }
				var f = $(this);
				if (f.prop('type') === 'hidden' || !f.is(':visible')) { return; }
				field = f.focus();
			});
		},
		validate: function (m) {
			var hasErrors = false, form = null;
			m = m || self.model;
			for (var f in m) {
				if (!self._isValid(f)) { continue; }
				if (!ko.isObservable(m[f])) { continue; }
				if (m[f] === null || m[f] === void 0) { continue; }
				if (form === null && m[f].validate !== void 0) { form = m[f].extended.form; }
				if (Array.isArray(m[f]())) {
					var arr = m[f]();
					for (var i = 0; i < arr.length; i++) {
						if (typeof (arr[i]) === 'object') {
							if (!self.events.validate(arr[i])) { hasErrors = true; }
						}
					}
				} else if (m[f]() !== null && m[f]() !== void 0 && typeof (m[f]()) === 'object') {
					if (!self.events.validate(m[f]())) { hasErrors = true; }
				} else if (typeof(m[f].validate) === 'function') {
					m[f].validate();
					if (typeof (m[f].hasError) === 'function' && m[f].hasError()) { hasErrors = true; }
				}
			}
			if (m === self.model && hasErrors) { self.events.focusFirst(form); }
			return !hasErrors;
		},
		save: function (callback) {
			if (!self.events.validate()) return;

			// add new item
			if (!self.model.Key()) {
				var item = {}, temp = {}, m = self.model.toJS();
				for (var f in m) {
					if (!self._isValid(f)) { continue; }
					temp[f] = m[f];
					if (m[f] === null || m[f] === void 0) { continue; }
					item[f] = m[f];
				}
				if (self.service.url) {
					ajaxJson('POST', self.service.url + '/' + self.service.methods.add, ko.toJSON(item), function (data) {
						if (!data.Errors) {
							$(self.summary).validationSummary();
							item = ko.utils.makeObservable(self.model, data);
							self.items.push(item);
							item.$parent = self;
							if (typeof callback === 'function') callback();
							self.dialog.close();
						}
						else {
							$(self.summary).validationSummary(data);
						}
					});
				} else {
					self.items.push(temp);
					temp.$parent = self;
					self.dialog.close();
				}
				// update existing
			} else {
				var old = self.items()[self.index()];
				var item = $.extend({}, old), m = self.model.toJS();
				for (var f in m) {
					if (!self._isValid(f)) { continue; }
					if (m[f] === null || m[f] === void 0) { continue; }
					item[f] = m[f];
				}

				if (!$(self.selector).length || self.index() == -1) return;

				// update database
				if (self.service.url) {
					delete item.$parent;
					ajaxJson('POST', self.service.url + '/' + self.service.methods.update, ko.toJSON(item), function (data) {
						if (!data.Errors) {
							$(self.summary).validationSummary();
							item = ko.utils.makeObservable(self.model, data);
							item.$parent = self;
							for (var f in data) if (ko.isObservable(old[f])) old[f](data[f]);
							if (typeof callback === 'function') callback();
							self.dialog.close();
						}
						else {
							$(self.summary).validationSummary(data);
						}
					});
				}
			}
		},
		'delete': function (item) { self.events.remove(item); },
		remove: function (item) {
			if (!self.events.confirm(item)) return;

			self.model.init(item);
			self.items.remove(item);
			if (!$(self.selector).length || self.index() == -1) return;

			// delete from database
			if (self.service.url) {
				var item = {};
				item[self.keyProperty()] = self.model.Key();
				ajaxJson('POST', self.service.url + '/' + self.service.methods.remove, ko.toJSON(item), function (data) {
					if (!data || data.Errors) { console.log('ERROR: Unable to remove item (' + self.model.Key() + ').'); }
				});
			}
		},
		confirm: function (item) {
			var t = $(self.selector);
			if (t.data('confirm-delete')) {
				var msg = t.data('confirm-message') || 'Are you sure you want to remove this item?';
				return confirm(msg);
			} else return true;
		},
		cancel: function () { self.dialog.close(); },
		empty: function () {
			for (var f in self.model) {
				if (!self._isValid(f)) continue;
				if (ko.isObservable(self.model[f])) {
					self.model[f](null);
					if (self.model[f].required()) self.model[f].validate(false);
				}
				else self.model[f] = null;
			}
		},
		afterRenderCallback: function () { },
		extend: function (extended) { $.extend(this, extended); }
	};
	self.items = ko.observableArray();
	self.items.extend = function (dataExt) { self.items.objExtend = dataExt; };
	self.items.init = function (arr, model) {
		if (!Array.isArray(arr)) return;
		self.items(ko.utils.makeObservable(model || self.model, ko.utils.extendArray(arr, self.items.objExtend)))
	};
	self.search = {
		viewModel: { query: '' },
		url: $(self.selector).data('search-url'),
		execute: function (obj, callback) {
			var t = $(this.selector);
			self.search.url = self.search.url || (self.service.url !== null ? self.service.url + '/' + self.service.methods.search : null);
			if (self.search.url === void 0 || self.search.url === null) {
				if (typeof (callback) === 'function') callback();
				return;
			}
			obj = obj ? obj : self.search.viewModel;
			if (typeof (obj) === 'string') { obj = { query: obj }; }

			ajaxJson('POST', self.search.url, ko.toJSON(obj), function (data) {
				if (Array.isArray(data)) self.items.init(data);
				else self.model.init(data);
				if (typeof (callback) === 'function') callback();
			});
		}
	}
};
ViewModel.prototype.bind = function (nodeId, afterRenderCallback) {
	var self = this, t = $(this.selector);
	var node = $(nodeId)[0] || $(self.selector)[0] || $('body')[0];

	if (!node || typeof node !== 'object' || node.nodeType !== 1) {
		console.error('Unable to bind view model to node. Node is not an element node.');
		return;
	}

	self.bindingSelector = $(nodeId)[0] ? nodeId : 'body';

	// after render callback
	if (typeof (afterRenderCallback) === 'function') {
		if (t.data('bind')) t.attr('data-bind', t.data('bind') + ', template: { afterRender: afterRenderCallback }');
		else t.attr('data-bind', 'template: { afterRender: afterRenderCallback }');
		self.afterRenderCallback = afterRenderCallback;
	}

	// knockoutjs binding
	ko.applyBindings(this, node);
	setTimeout(function () { $(t).attr('data-bound', true); });

	node.viewModel = self;
}

// custom knockout driven data grid
var DataGrid = function (tableSelector) {
	ViewModel.call(this, tableSelector); // call parent constructor
	var self = this;
	self.parent = DataGrid.prototype;
	self._columnIndexes = function (cssClass) {
		var arr = new Array();
		$(self.selector + ' > thead th.' + cssClass + ', ' + self.selector + ' > thead td.' + cssClass).each(function () { arr.push($(this).index()); });
		return arr;
	};
	self._tbody = function () { return $(self.selector + ' > tbody:not([data-body="false"])').first(); };
	self.responsive = {
		enabled: $(self.selector).data('responsive') || false,
		columns: {
			all: self._columnIndexes('all'),
			none: self._columnIndexes('none'),
			never: self._columnIndexes('never'),
			control: self._columnIndexes('control')
		},
		expandColumns: ko.observable(0).extend({ numeric: 0 })
	};
	self.responsive.visibleColumns = ko.computed(function () {
		var cols = $(self.selector + ' > thead > tr > *').length;
		return !this.enabled ? cols - this.columns.control.length :
			this.expandColumns() === 0 ? cols - this.columns.control.length - this.columns.never.length :
				cols - this.columns.never.length - this.expandColumns() - (self.items().length ? 0 : this.columns.control.length);
	}, this.responsive);
	self.sorting = $(self.selector).data('sorting') || false;
	self.events.remove = function (item) {
		if (!self.events.confirm(item)) return;

		self.model.init(item);
		if (!$(self.selector).length || self.index() == -1) return;

		// delete from database
		if (self.service.url) {
			var item = {};
			item[self.keyProperty()] = self.model.Key();
			ajaxJson('POST', self.service.url + '/' + self.service.methods.remove, ko.toJSON(item), function (data) {
				if (!data || data.Errors) { console.log('ERROR: Unable to remove item (' + self.model.Key() + ').'); }
				else if (data.Success || data === true || typeof (data) === 'string') {
					// update from DOM if still exists
					self.items.remove(item);
					$(self.selector + ' tbody > tr[data-id]').each(function (index) {
						if ($(this).data('id') == self.model.Key()) {
							self.index(index);
							var x = $(this).next();
							if (x.hasClass('child')) x.remove();
							$(this).remove();
							return;
						}
						self.search.execute();
					});
				} else {
					self.pager.init(data);
				}
			});
		}
	};
	self.events.refresh = function () {
		if (!self.responsive.enabled) return;
		var t = $(self.selector);
		if (!t.is(':visible')) return;
		var cw = t.parent().width(), tw = t.outerWidth(), w = $(window).width();
		var direction = w > self.events.resize.lastSize ? 1 : -1;
		self.events.resize.lastSize = w;

		if (tw > cw) {
			var hcols = t.find('thead th');
			for (var i = hcols.length; i > -1; i--) {
				var h = $(hcols[i]);
				if (h.hasClass('never') || h.hasClass('all') || h.hasClass('none') || h.hasClass('controls')) continue;
				tw -= h.width() - 1;
				h.addClass('expandable');
				var bcols = t.find('tbody > tr > td:nth-child(' + (i + 1) + ')').each(function () { $(this).addClass('expandable'); });
				self.responsive.expandColumns(t.find('thead .expandable').length);

				t.find('tbody > tr.parent').each(function () {
					var child = $(this).next();
					if (!child.hasClass('child')) {
						$(this).removeClass('.parent');
						return;
					}
					var div = child.find('.expandable-content');
					div.html('');
					div.append(self.events.expandableContent(this));
				});
				cw = t.parent().width();
				if (tw <= cw) break;
			}
		} else if (direction === 1) {
			var exp = t.find('thead th.expandable:not(.none)').first();
			var idx = exp.index();
			if (exp.length) {
				exp.removeClass('expandable');
				var bcols = t.find('tbody > tr > td:nth-child(' + (idx + 1) + ')');
				bcols.each(function () { $(this).removeClass('expandable'); });
				if (t.outerWidth() > cw) {
					exp.addClass('expandable');
					bcols.each(function () { $(this).addClass('expandable'); });
				} else {
					tw = t.outerWidth();
					self.responsive.expandColumns(t.find('thead .expandable').length);

					if (self.responsive.expandColumns() === 0) t.find('tr').each(function () { $(this).removeClass('parent'); if ($(this).hasClass('child')) $(this).remove(); })
					t.find('tbody > tr').each(function () {
						var child = $(this).next();
						if (!child.hasClass('child')) $(this).removeClass('parent');
						else {
							child.children().attr('colspan', $(this).children(':visible').length);
							var div = child.find('.expandable-content');
							div.html('');
							div.append(self.events.expandableContent(this));
						}
					});
				}
			}
		}
	};
	self.events.expandableContent = function (row) {
		var ctx = this, row = (row instanceof $) ? row : $(row), div = $('<DIV/>');
		row.children('.expandable').each(function (i) {
			var label = row.parent().siblings('thead').find('tr > .expandable')[i];
			var labelText = row.parent().siblings('thead').find('tr > .expandable')[i].innerHTML;
			if ($(this).data('header')) { labelText = $(this).data('header'); }
			else if ($(label).children().length) {
				if ($(labelText).prop('tagName') === 'A' || $(labelText).prop('tagName') === 'SPAN') {
					labelText = $(labelText).html();
				}
			}
			var dd = $('<DD/>').html(this.innerHTML);
			ko.applyBindingsToDescendants(ko.contextFor(row[0]), dd[0]);
			div.append($('<DL/>').attr('data-column', i).append($('<DT/>').text(labelText + ': ')).append(dd));
		});
		return div.children();
	};
	self.events.resize = function (event) { self.events.refresh(); };
	self.events.resize.lastSize = 10000;
	self.events.expandToggle = function (index) {
		index = typeof (index) === 'function' ? index() : index;
		var tbody = self._tbody();
		if (index === -1) {
			var rows = tbody.children('tr:not(.child)').length;
			var clps = tbody.children('tr:not(.parent):not(.child)').length;
			var all = $(self.selector + ' > thead > tr');
			if (clps === 0) all.removeClass('parent');
			else all.addClass('parent');
			for (var i = 0; i < rows; i++) {
				if (clps === 0) { self.events.collapse.call(self.items()[i], i); }
				else { self.events.expand.call(self.items()[i], i); }
			}
			return;
		}
		if ($(tbody.children('tr:not(.child)')[index]).hasClass('parent')) { self.events.collapse.call(this, index); }
		else { self.events.expand.call(this, index); }
	};
	self.events.collapseAll = function (speed) {
		var tbody = self._tbody();
		var rows = tbody.children('tr:not(.child)').length;
		var clps = tbody.children('tr:not(.parent):not(.child)').length;
		$(self.selector + ' > thead > tr').removeClass('parent');

		for (var i = 0; i < rows; i++) {
			self.events.collapse.call(self.items()[i], i, speed);
		}
	};
	self.events.expand = function (index, speed) {
		index = typeof (index) === 'function' ? index() : index;
		speed = speed === null || speed === void 0 ? 200 : speed;
		var tbody = self._tbody();
		var row = $(tbody.children('tr:not(.child)')[index]);
		var next = row.next();
		if (row.hasClass('parent')) { return; }	

		row.addClass('parent');
		var div;
		if (next.hasClass('child')) { div = next.find('.expandable-content'); }
		else {
			row.children('.control').attr('aria-label', 'Collapse');
			var xrow = $(row.parent()[0].insertRow(row.index() + 1)).addClass('child');
			xrow.attr('data-id', row.data('id'));
			div = $('<DIV/>').addClass('expandable-content');
			div.append(self.events.expandableContent.call(this, row));
			xrow.append($('<TD/>').attr('colspan', row.children(':visible').length).append(div));
		}
		if (tbody.children('tr:not(.parent):not(.child)').length === 0) { $(self.selector + ' > thead > tr').addClass('parent'); }
		var scrollHeight = div[0].scrollHeight;
		div.animate({ height: scrollHeight, 'padding-top': '10px', 'padding-bottom': '10px' }, speed, 'swing', function () {
			$(this).css({ height: 'auto' });
		});
	};
	self.events.collapse = function (index, speed) {
		index = typeof (index) === 'function' ? index() : index;
		speed = speed === null || speed === void 0 ? 200 : speed;
		$(self.selector + ' > thead > tr').removeClass('parent');

		var tbody = self._tbody();
		var row = $(tbody.children('tr:not(.child)')[index]);
		var next = row.next();
		if (!row.hasClass('parent')) return;

		row.children('.control').attr('aria-label', 'Expand');
		if (!next.hasClass('child')) { row.removeClass('parent'); return; }
		next.find('.expandable-content').animate({ height: 0, 'padding-top': 0, 'padding-bottom': 0 }, speed, function () {
			row.removeClass('parent');
			next.remove();
		});
	};
	self.events.afterRenderCallback = function () { self.events.refresh(); };
	self.paging = $(self.selector).data('paging') || false;
	self.pager = {
		init: function (ps, model) {
			var children = [];
			var tbody = self._tbody();
			if (self.responsive.enabled) { children = tbody.children('tr.child'); }
			if (Array.isArray(ps)) self.items(ko.utils.makeObservable(model || self.model, ko.utils.extendArray(ps, self.items.objExtend)));
			else {
				self.editable(ps.Editable);
				self.items.init(ps.Items, model || self.model);
				if (self.responsive.enabled) { self.events.refresh(); }
				self.pager.pages.removeAll();
				if (ps.PageCount) {
					if (ps.PageCount > 2) self.pager.pages.push({ label: '<<' });
					self.pager.pages.push({ label: '<' });

					var start = (ps.PageCount > 10 && ps.CurrentPage > 6) ? ps.CurrentPage > ps.PageCount - 8 ? ps.PageCount - 8 : (ps.CurrentPage - 4) : 0;
					if (start >= 2) {
						self.pager.pages.push({ label: 1 });
						self.pager.pages.push({ label: '...' });
					}
					var end = (ps.PageCount > 10 && ps.CurrentPage > 6) ? ps.CurrentPage + 3 : (ps.PageCount > 10) ? 9 : ps.PageCount;
					if (end > ps.PageCount) end = ps.PageCount;
					for (var i = start; i < end; i++) {
						self.pager.pages.push({ label: i + 1 });
					}
					if (end < ps.PageCount - 4) {
						self.pager.pages.push({ label: '...' });
						self.pager.pages.push({ label: ps.LastPage });
					}
					self.pager.pages.push({ label: '>' });
					if (ps.PageCount > 2) self.pager.pages.push({ label: '>>' });
				}
				ps.Items = null;
				self.pager.pagerSorter(ps);
			}
			if (!self.keyProperty() && self.items.length > 0) {
				for (var p in self.items()[0]) {
					if (p.indexOf('ID') > -1) {
						self.keyProperty(p);
						break;
					}
				}
			}
			if (children.length) {
				children.each(function () {
					var child = $(this).remove();
					var parent = tbody.children('tr[data-id="' + child.data('id') + '"]:not(.child)');
					parent.after(child);
					if (!parent.hasClass('parent')) { parent.addClass('parent'); }
				});
			}
		},
		pagerSorter: ko.observable(),
		isServerSide: ko.computed(function () {
			return self.pager.pagerSorter() !== null && self.pager.pagerSorter() !== void 0;
		}, self.pager, { deferEvaluation: true }),
		pages: ko.observableArray([]),
		url: $(self.selector).data('pager-url'),
		active: function (i) {
			if (self.pager.pagerSorter() && parseInt(i) === self.pager.pagerSorter().CurrentPage) return true;
			return false;
		},
		enabled: function (i) {
			if (self.pager.pagerSorter() === undefined) return false;
			if (typeof (i) === 'function') { i = i(); }
			if (i === 0 && self.pager.pagerSorter().CurrentPage === 1) return false;
			else if (i === (self.pager.pagerSorter().PageCount + 1) && self.pager.pagerSorter().CurrentPage === self.pager.pagerSorter().PageCount) return false;
			return true;
		},
		click: function (i) {
			if (self.pager.isServerSide()) {
				self.pager.url = self.pager.url || (self.service.url !== null ? self.service.url + '/' + self.service.methods.pager : null);
				var ps = self.pager.pagerSorter(), n = ps.CurrentPage;
				if (i === '...') return false;

				if (i === '<') n--; else if (i === '>') n++; else if (i === '<<') n = 1; else if (i === '>>') n = ps.PageCount; else n = i;
				if (n === 0 || n > ps.PageCount) return false;

				ps.CurrentPage = n;
				self.pager.pagerSorter(ps);

				ajaxJson('POST', self.pager.url, ko.toJSON(self.pager.pagerSorter()), function (data) { self.pager.init(data); });
			} else {
				// 2DO: IMPLEMENT CLIENT SIDE PAGINATION
			}
		},
		sort: function (val, index) {
			self.pager.url = self.pager.url || (self.service.url !== null ? self.service.url + '/' + self.service.methods.pager : null);
			if (self.pager.isServerSide()) {
				var ps = self.pager.pagerSorter();
				if (ps.SortBy != val) {
					ps.SortDirection = 0;
					self.pager._direction = -1;
				} else {
					ps.SortDirection = !ps.SortDirection ? 1 : 0;
					self.pager._direction = ps.SortDirection ? 1 : -1;
				}
				ps.SortBy = val;
				self.pager.pagerSorter(ps);
				ajaxJson('POST', self.pager.url, ko.toJSON(ps), function (data) { self.pager.init(data); });
			} else {
				if (!self.model.hasOwnProperty(val)) return;
				if (self.pager._direction === undefined || self.pager._current !== val) self.pager._direction = -1;
				self.pager._current = val;
				var d = self.pager._direction *= -1;
				self.items.sort(function (a, b) {
					var a = (ko.isObservable(a[val])) ? a[val]() : a[val];
					var b = (ko.isObservable(b[val])) ? b[val]() : b[val];
					return a < b ? d * -1 : a > b ? d : a == b ? 0 : 0;
				});
			}
			if (index !== void 0) {
				$(self.selector + ' > thead > tr > th').each(function () { $(this).removeClass('sorted').removeClass('sorted-asc').removeClass('sorted-desc'); });
				var th = $(self.selector + ' > thead > tr > th:nth-child(' + (index + 1) + ')').addClass('sorted');
				if (self.pager._direction === 1) th.addClass('sorted-desc');
				else th.addClass('sorted-asc');
			}
			if (self.responsive.enabled) {
				var tbody = self._tbody();
				var children = tbody.children('tr.child').each(function () {
					var child = $(this).remove();
					tbody.children('tr.parent[data-id="' + child.data('id') + '"]').after(child);
				});
			}
		}
	}
	self.search = {
		viewModel: { query: '' },
		autoExecute: $(self.selector).data('service-url') || $(self.selector).data('search-url') ? true : false,
		url: $(self.selector).data('search-url'),
		click: function () {
			self.search.viewModel.query = $(self.selector + ' .search-input').val();
			self.search.execute();
		},
		execute: function (obj, callback) {
			var t = $(this.selector);
			self.search.url = self.search.url || (self.service.url !== null ? self.service.url + '/' + self.service.methods.search : null);
			if (self.search.url === void 0 || self.search.url === null) {
				if (typeof (callback) === 'function') callback();
				return;
			}
			obj = obj ? obj : self.search.viewModel;

			ajaxJson('POST', self.search.url, ko.toJSON(obj), function (data) {
				var items = data.Items;
				self.pager.init(data);
				if (typeof (callback) === 'function') callback(items || data);
			});
		}
	}
};

// static methods
DataGrid._buildStaticData = function (self, t, tbody) {
	var head = t.find('thead > tr > th:not(.control)');
	head.each(function (h) {
		var hasDataBind = $(this).find('[data-field], [data-bind]').length > 0;
		var hasDataField = $(this).data('field');
		if (!hasDataField && hasDataBind) { return; }
		else if (!hasDataField) {
			$(this).attr('data-field', $(this).text().replaceAll(/[/\s\(\)',\-#$&.]/g, ''));
			hasDataField = true;
		}

		var td = tbody.find('tr:first-child > td:not(.control):eq(' + h + ')');
		if (hasDataField) { td.attr('data-field', $(this).hasClass('controls') ? 'controls' : $(this).data('field')); }
	});
	var rows = tbody.children('tr');
	tbody.children('tr').each(function (r) { if (r > 0) $(this).remove(); });

	var _hasControlsBinding = false;
	for (var r = 0; r < rows.length; r++) {
		var cells = $(rows[r]).find('td:not(.control)');
		var item = {};
		for (var c = 0; c < cells.length; c++) {
			if ($(head[c]).hasClass('controls') && $(cells[c]).find('[data-bind]').length > 0) { _hasControlsBinding = true; continue; }
			item[$(head[c]).hasClass('controls') ? 'controls' : $(cells[c]).data('field') || $(head[c]).data('field') || $(head[c]).text().replaceAll(' ', '')] = $(cells[c]).html();
		}
		self.items.push(item);
	}

	if (!_hasControlsBinding) { tbody.find('.controls:not(.control)').attr('data-field', 'controls'); }

	if (self.responsive.enabled) {
		var th = t.find('thead th.control').first();
		if (!th.length) { t.find('thead > tr').prepend($('<TH/>').addClass('controls control').attr('data-bind', 'visible: items().length > 0, click: events.expandToggle.bind($data, -1)')); }

		var td = tbody.find('td.control').first();
		if (!td.length) { tbody.children('tr:first-child').prepend($('<TD/>').addClass('controls control').attr('data-bind', 'click: $root.events.expandToggle.bind($data, $index())')); }
	}

	return $(self.selector);
};
DataGrid._renderHeader = function (self, t) {
	// responsive check
	if (self.responsive.enabled) {
		t.attr('data-bind', 'css: { expandable: responsive.expandColumns() > 0 }');
		self.responsive.expandColumns(self.responsive.expandColumns() + self.responsive.columns.none.length);
		$(window).resize(function (event) { self.events.resize(event); });
	}

	// add searching
	var captemp = t.find('caption');
	if (t.data('searching')) {
		if (!t.find('.search-input').length) {
			captemp.remove();
			var cap = $('<CAPTION/>');
			var row = $('<DIV/>').addClass('row');
			var col1 = $('<DIV/>').addClass('col-sm-8 col-xs-12');
			if (captemp.length) col1.html(captemp.html());
			else col1.append($('<H2/>').html(self.title));
			var col2 = $('<DIV/>').addClass('col-sm-4 col-xs-12 text-right');
			var grp = $('<DIV/>').addClass('input-group input-group-sm');
			var txt = $('<INPUT/>').attr('type', 'search').attr('placeholder', 'Search...').attr('data-bind', 'onDelay: search.click, onEnter: search.click').addClass('form-control search-input');
			var span = $('<DIV/>').addClass('input-group-btn');
			var btn = $('<BUTTON/>').attr('type', 'button').attr('data-bind', 'click: search.click').addClass('btn btn-theme');
			var glyph = $('<SPAN/>').addClass('glyphicons glyphicons-search');
			t.prepend(cap.append(row.append(col1).append(col2.append(grp.append(txt).append(span.append(btn.append(glyph)))))));
		}
	}

	// header labels if empty
	t.find('thead th[data-field], thead td[data-field]').each(function () { if (!$(this).html().length) $(this).text($(this).data('field')); });

	// add sorting
	t.find('[data-sortable=true]').each(function () {
		var th = $(this);
		if (th.find('a').length) return;
		var f = th.data('field') || (th.children().length ? '' : th.text());
		//if (self.model.hasOwnProperty(f)) th.attr('data-field', f); else return;
		th.html($('<A/>').attr('href', '#').attr('data-bind', "click: pager.sort.bind($data, '" + f + "'," + th.index() + ")").html(th.html()));
	});
};
DataGrid._renderBody = function (self, t, tbody, afterRenderCallback) {
	// after render callback
	if (t.data('bind')) t.attr('data-bind', t.data('bind') + ', template: { afterRender: events.afterRenderCallback }');
	else t.attr('data-bind', 'template: { afterRender: events.afterRenderCallback }');
	if (typeof (afterRenderCallback) === 'function') {
		var r = self.events.afterRenderCallback;
		self.events.afterRenderCallback = function () {
			if (typeof (r) === 'function') { r(); }
			afterRenderCallback();
		}
	}

	// tbody row binding
	if (tbody.length === 0) { t.children('thead').last().after($('<TBODY/>')); }
	tbody = self._tbody();
	with (tbody.first()) {
		if (!data('bind')) attr('data-bind', 'visible: items().length > 0, foreach: { data: items, afterAdd: $root.responsive.refresh }');
		if (!children().length) {
			var tr = $('<TR/>');
			if (self.keyProperty()) tr.attr('data-bind', "attr: { 'data-id': $data[$root.keyProperty()] }");
			else tr.attr('data-bind', "attr: { 'data-id': $index() }");
			t.find('thead > tr > th').each(function () {
				var th = $(this);
				var td = $('<TD/>');
				if (th.hasClass('controls') || th.hasClass('control')) {
					if (th.hasClass('controls')) {
						td.addClass('controls');
						if (th.data('controls')) {
							var controls = th.data('controls').replaceAll(' ', '').split(',');
							for (var i = 0; i < controls.length; i++) {
								var c = controls[i];
								if (typeof (self.events[c]) !== 'function') continue;
								var a = $('<A/>').addClass(c).attr('data-bind', 'click: $root.events.' + c);
								td.append(a);
							}
						}
					}
					tr.append(td);
				} else { tr.append(td.attr('data-bind', 'html: ' + (th.data('field') || "''")).addClass(th.data('class') || 'col')); }
			});
			append(tr);
		} else {
			tbody.children('tr').each(function () {
				if ($(this).is('[data-bind]')) { return; }
				$(this).attr('data-bind', "attr: { 'data-id': " + (self.keyProperty() ? '$data[$root.keyProperty()]' : '$index()') + ' }');
			});
			tbody.find('[data-field]').each(function () { $(this).attr('data-bind', 'html: ' + $(this).data('field')); });
		}
		if (t.find('tbody:not([data-body="false"])').length === 1) {
			after($('<TBODY/>').attr('data-bind', 'visible: items().length == 0').append($('<TR/>').append($('<TD/>').attr('data-bind', 'attr: { colspan: responsive.visibleColumns }').text(t.data('emptyrowtext') || 'No items found.'))));
		}

		// add responsive class logic to body columns
		t.find('thead th.none').each(function () { $(this).addClass('expandable'); });
		tbody.find('tr > td').each(function (i) {
			for (var c in self.responsive.columns) {
				if (self.responsive.columns[c].contains(i)) $(this).addClass(c);
			}
		});
	}
};
DataGrid._renderResponsive = function (self, t, tbody) {
	// responsive controls
	if (self.responsive.enabled) {
		tbody.find('tr > td').each(function (i) {
			for (var c in self.responsive.columns) { if (self.responsive.columns[c].contains(i)) { $(this).addClass(c); } }
		});

		var th = t.find('thead th.control').first();
		if (!th.data('bind')) th.attr('data-bind', 'visible: items().length > 0, click: events.expandToggle.bind($data, -1)');
		tbody.find('td.control').each(function () {
			if (!$(this).data('bind')) $(this).attr('data-bind', 'click: $root.events.expandToggle.bind($data, $index())');
		});

		// add responsive class logic to body columns
		t.find('thead .none').each(function () { $(this).addClass('expandable'); });
		tbody.find('.none').each(function () { $(this).addClass('expandable'); });
	}
};
DataGrid._renderPager = function (self, t) {
	// add pager
	if (self.paging) {
		if (!t.find('.pagination').length) {
			var foot = t.children('tfoot');
			if (!foot[0]) foot = $('<TFOOT/>');
			foot.attr('data-bind', 'visible: pager.pagerSorter() && pager.pagerSorter().PageCount > 1');

			var tr = $('<TR/>');
			var td = $('<TD/>').attr('data-bind', 'attr: { colspan: responsive.visibleColumns }');
			var nav = $('<NAV/>');
			var ul = $('<UL/>').addClass('pagination').attr('data-bind', 'foreach: pager.pages');
			var li = $('<LI/>').attr('data-bind', 'css: {active: $root.pager.active(label) }');
			var a = $('<A/>').attr('href', '#').attr('aria-hidden', 'true').attr('data-bind', 'text: label, css: { disabled: !$root.pager.enabled($index()) }, click: $root.pager.click.bind($data, label)');
			t.append(foot.append(tr.append(td.append(nav.append(ul.append(li.append(a)))))));
		}
	}
};

// extend parent
DataGrid.prototype = new ViewModel();
DataGrid.prototype.constructor = DataGrid;
DataGrid.prototype.bind = function (nodeId, afterSearchCallback, afterRenderCallback) {
	var node = $(nodeId)[0] || $('body')[0];
	var self = this, t = $(this.selector);
	var tbody = self._tbody();
	self.bindingSelector = $(nodeId)[0] ? nodeId : 'body';

	if (t.data('keyproperty')) { self.keyProperty(t.data('keyproperty')); }

	// build data array if static
	var isStaticData = !self.search.autoExecute && self.items().length === 0 && t.data('initialize') !== false;
	if (isStaticData) { t = DataGrid._buildStaticData(self, t, tbody); }

	// render components
	DataGrid._renderHeader(self, t);
	DataGrid._renderBody(self, t, tbody, afterRenderCallback);
	DataGrid._renderResponsive(self, t, tbody);
	DataGrid._renderPager(self, t);

	// initial data w/ callback
	if (!self.items().length && self.search.autoExecute) {
		self.search.viewModel.query = '';
		self.search.execute(null, afterSearchCallback);
	}

	// knockoutjs binding
	ko.applyBindings(this, node);
	$(t).attr('data-bound', true);

	if (nodeId !== void 0) { node.dataGrid = self; }
	else { t[0].dataGrid = self; }

	// column header hover
	t.find('thead > tr > th').each(function (index) {
		var hoverHandler = function (event) { tbody.find('tr > td:nth-child(' + (index + 1) + ')').toggleClass('hover'); };
		$(this).hover(hoverHandler, hoverHandler);
	});
}

// extend jQuery
jQuery.fn.extend({
	viewModel: function () { return this.length > 0 && this[0].viewModel !== void 0 ? this[0].viewModel : null; },
	isViewModel: function () { return this.length > 0 ? this[0].hasOwnProperty('viewModel') : false; },
	dataGrid: function () { return this.length > 0 && this[0].dataGrid !== void 0 ? this[0].dataGrid : null; },
	isDataGrid: function () { return this.length > 0 ? this[0].hasOwnProperty('dataGrid') : false; }
});

// auto binding
$(function () {
	$('.datagrid').each(function (i) {
		if ($(this).attr('id') === undefined || $(this).attr('id') === null) $(this).attr('id', 'datagrid_' + i);
		if ($(this).data('bound') || $(this).data('initialize') === false) return;
		var dg = new DataGrid('#' + $(this).attr('id'));
		var kp = $(this).data('keyproperty');
		if (kp) { dg.model[kp] = ko.observable(); }
		dg.bind(dg.selector);
	});
});

// extend knockout root
(function (k) {
	'use strict';

	// build basic pager
	k.pager = function (vm, settings) {
		var self = this;
		settings = settings || {};
		vm = vm || {};
		vm.items = vm.items || function () { return settings.items || []; };
		self.busyBox = settings.busyBox || null;
		self.pagerSorter = ko.observable();
		self.pagerCallback = settings.pagerCallback || null;
		self.pagerUrl = ko.observable(settings.pagerUrl);
		self.pageSize = ko.observable(settings.pageSize || 5);
		self.pageCount = ko.computed(function () {
			if (self.pagerSorter()) { return self.pagerSorter().PageCount; }
			var n = self.pageSize(), x = this.items().length;
			if (n === 0) { return 0; }
			return Math.floor(x / n) + (x % n > 0 ? 1 : 0);
		}, vm);
		self.pages = ko.observableArray();
		self.filtered = ko.observableArray();
		self.filtered.subscribe(function (value) {
			var p = new Array(), count = self.pageCount(), active = self.active() + 1;
			if (count > 2) { p.push({ label: '&lt;&lt;' }); }
			p.push({ label: '&lt;' });

			var start = count > 6 && active > 4 ? active > count - 4 ? count - 5 : active - 1 : 0;
			if (start >= 2) { p.push({ label: '...' }); }

			var end = count > 6 && active > 4 && active < count - 4 ? active + 3 : count > 6 && active <= 4 ? 5 : count;
			if (end > count) end = count;
			for (var i = start; i < end; i++) { p.push({ label: i + 1 }); }
			if (end < count - 1) { p.push({ label: '...' }); }

			p.push({ label: '&gt;' });
			if (count > 2) { p.push({ label: '&gt;&gt;' }); }
			self.pages(p);
		});
		self.active = ko.observable(-1).bypassable();
		self.active.subscribe(function (value) {
			if (value < 0) { return; }
			if (value >= self.pageCount()) { value = self.pageCount() - 1; }
			if (self.pagerSorter()) {
				if (self.pagerUrl() === void 0) { return; }
				var ps = self.pagerSorter();
				ps.CurrentPage = value + 1;
				if (self.busyBox !== null) { self.busyBox.Show(1000); }
				ajaxJson('POST', self.pagerUrl(), ko.toJSON(ps), function (data) {
					self.init(data);
					if (self.busyBox !== null) { self.busyBox.Hide(); }
					if (typeof (self.pagerCallback) === 'function') { self.pagerCallback(); }
				});
				return;
			}
			var s = self.pageSize();
			self.filtered(vm.items().slice(value * s, value * s + s));
		});
		self.disabled = function (value) {
			return (self.active() === 0 && ['&lt;', '&lt;&lt;'].contains(value)) || (self.active() + 1 === self.pageCount() && ['&gt;', '&gt;&gt;'].contains(value));
		};
		self.init = function (items) {
			if (items === null || (Array.isArray(items) && items.length === 0)) {
				self.active(-1);
				self.filtered.removeAll();
				return;
			} else if (items.hasOwnProperty('RecordsPerPage')) {
				var ps = items;
				items = ps.Items;
				ps.items = null;
				self.pageSize(ps.RecordsPerPage);
				self.active.withBypass(ps.CurrentPage-1);
				self.pagerSorter(ps);
				self.filtered(items);
				return;
			}
			self.active.withBypass(0);
			self.filtered(items.slice(0, self.pageSize()));
		};
		self.visible = ko.computed(function () { return this.pageCount() > 1; }, self);
		self.click = function (data, event) {
			if (isNaN(this.label)) {
				if (this.label === '&lt;&lt;') { self.active(0); }
				else if (this.label === '&lt;' && self.active() > 0) { self.active(self.active() - 1); }
				else if (this.label === '&gt;' && self.active() < self.pageCount() - 1) { self.active(self.active() + 1); }
				else if (this.label === '&gt;&gt;') { self.active(self.pageCount() - 1); }
				else if (this.label === '...') {
					var b = $(event.currentTarget);
					b.popover({
						title: '<button class="close pull-right" role="button" type="button" onclick="$(this).closest(\'.popover\').popover(\'destroy\');">&times;</button> Page',
						content: '<div id="PageJumpTo" class="input-group input-group-sm" style="width:105px;"><input type="number" next="1" min="1" step="1" class="form-control text-right" pattern="[0-9]" value="' + (self.active() + 1) + '" />' +
							'<div class="input-group-btn"><button type="button" class="btn btn-primary"><span class="glyphicons glyphicons-riflescope"></span></button></div></div>',
						html: true,
						placement: 'top'
					}).popover('show');
					var goto = function (i) {
						if (isNaN(i) || i <= 0) { return; }
						self.active(parseInt(i) - 1);
						b.popover('destroy');
					};
					$('#PageJumpTo .form-control').focus().off('keypress.pager').on('keypress.pager', function (e) {
						if ((e.which || e.keyCode) === 13) { goto($(this).val()); }
					});
					$('#PageJumpTo .btn').off('click.pager').on('click.pager', function () { goto($('#PageJumpTo .form-control').val()); });
				}
				return;
			}
			self.active(this.label - 1);
		};
	};

	k.subscribable.fn.trimmed = function () {
		return k.computed({
			read: function () {
				return this().trim();
			},
			write: function (value) {
				this(value.trim());
				this.valueHasMutated();
			},
			owner: this
		}).extend({ notify: 'always' });
	};
})(ko);

// knockout extenders
(function (x) {
	'use strict';

	// base extended object
	var Extended = function (target) {
		var self = this;
		self.label = null;
		self.form = null;
		self.hasValidator = false;
		self.notify = function () {
			if ((!self.form || self.form.length === 0) && self.label !== null) { self.form = $(self.label).closest('form'); }
			if (target.hasError()) { $(self.label).closest('.form-group').addClass('has-error'); }
			else { $(self.label).closest('.form-group').removeClass('has-error'); }
		}
	};

	// set a default value if NULL
	x.defaultIfNull = function (target, defaultValue) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				if (!newValue) target(defaultValue);
				else target(newValue);
			}
		});
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.defaultIfNull = defaultValue;
		return result;
	};

	// set a max length and truncate anything longer
	x.maxLength = function (target, max) {
		var result = ko.computed({
			read: target,
			write: function (value) {
				if (value !== null && value !== undefined && value.length > max) {
					var newValue = value.substring(0, max);
					target(newValue);
					target.notifySubscribers(newValue);
				} else target(value);
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.maxLength = max;
		return result;
	};

	// validate all validators
	x.validate = function (param) {
		var target = this;
		if (!ko.isObservable(target) || !target.validators) return true;
		for (var i = 0; i < target.validators.length; i++) {
			if (!target.validators[i].call(target, param))
				return false;
		}
		return true;
	}

	// set a required field validator
	x.required = function (target, params) {
		if (typeof (params) === 'boolean') {
			if (params === false) { return target; }
			params = {};
		} else if (typeof (params) === 'string') {
			params = { label: params };
		}
		params.label = params.label || '<LABEL/>';

		target.extended = target.extended || new Extended(target);
		target.extended.label = target.extended.label || params.label;
		delete (params.label);
		target.extended.required = params;
		target.extended.form = target.extended.form || $(target.extended.label).closest('form');
		target.required = ko.observable(true);
		target.hasError = target.hasError || ko.observable(false);

		target.validators = target.validators || [];
		$(target.extended.label).addClass('required');

		target.validators.push(function requiredValidator(checkForErrors) {
			target.required(checkForErrors === true);
			if (typeof (target.extended.required.assert) === 'function') {
				target.required(target.extended.required.assert.apply(target));
			}
			var v = target();
			target.hasError((v === void 0 || v === null || v === '' || (Array.isArray(v) && v.length === 0)) && target.required());
			target.extended.notify();
			return !target.hasError();
		});

		target.validate = target.validate || x.validate;
		if (!target.extended.hasValidator) {
			target.subscribe(target.validate, target);
			target.extended.hasValidator = true;
		}
		return target;
	};

	// set a pattern validator
	x.pattern = function (target, options) {
		if (options === null || options === void 0) {
			options = { pattern: null, label: '<LABEL/>' };
		} else if (typeof (options) === 'string') {
			options = { pattern: options, label: '<LABEL/>' };
		}
		target.extended = target.extended || new Extended(target);
		target.extended.pattern = options.pattern || target.extended.pattern;
		target.extended.label = target.extended.label || options.label;
		target.extended.form = target.extended.form || $(options.label).closest('form');
		target.hasError = target.hasError || ko.observable(false);

		target.validators = target.validators || [];
		target.validators.push(function patternValidator() {
			if (target() == '' || target() == void 0 || target() == null || target.extended.pattern === void 0 || target.extended.pattern === null) { return true; }

			var pattern = new RegExp(target.extended.pattern);
			target.hasError(!pattern.test(target()));
			target.extended.notify();
			return !target.hasError();
		});

		target.validate = target.validate || x.validate;
		if (!target.extended.hasValidator) {
			target.subscribe(target.validate, target);
			target.extended.hasValidator = true;
		}
		return target;
	};

	// add an assert validator
	x.assert = function (target, assert) {
		var settings = assert;
		if (typeof (settings) === 'function') { settings = { assert: assert, label: '<LABEL/>' }; }

		target.extended = target.extended || new Extended(target);
		target.extended.assert = settings.assert;
		target.extended.label = target.extended.label || settings.label;
		target.extended.form = target.extended.form || $(settings.label).closest('form');
		target.hasError = target.hasError || ko.observable(false);

		target.validators = target.validators || [];
		target.validators.push(function assertValidator() {
			if (typeof (target.extended.assert) === 'function') {
				target.hasError(!target.extended.assert.apply(target));
			}
			target.extended.notify();
			return !target.hasError();
		});

		target.validate = target.validate || x.validate;
		if (!target.extended.hasValidator) {
			target.subscribe(target.validate, target);
			target.extended.hasValidator = true;
		}
		return target;
	};

	// ensure value is numeric and round according to decimal precision
	x.numeric = function (target, precision) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				if (newValue === null || newValue === '') { target(null); return; }
				var current = target(),
					roundingMultiplier = Math.pow(10, precision),
					newValueAsNum = isNaN(newValue) ? 0 : parseFloat(+newValue),
					valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;
				if (valueToWrite !== current) target(valueToWrite);
				else {
					// rounded value != value
					if (newValue !== current) {
						if (newValue === null || newValue === '') { target.notifySubscribers(null); return; }
						else target.notifySubscribers(valueToWrite);
					}
				}
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.numeric = precision;
		return result;
	};

	// ensure value is integer
	x.integer = function (target, defaultValue) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				if (newValue === null || newValue === '') { target(null); return; }
				var current = target(), valueToWrite = isNaN(newValue) ? defaultValue : parseInt(newValue);
				if (valueToWrite !== current) target(valueToWrite);
				else if (newValue !== current) {
					if (newValue === null || newValue === '') { target.notifySubscribers(null); return; }
					else target.notifySubscribers(valueToWrite);
				}
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.integer = defaultValue;
		return result;
	};

	// ensure value is only the date and not time
	x.dateOnly = function (target, isDateOnly) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				if (newValue === null || newValue === '') { target(null); return; }
				var current = target(), valueToWrite = isDateOnly ? new Date(newValue).toString('MM/dd/yyyy') : newValue;
				if (valueToWrite !== current) target(valueToWrite);
				else if (newValue !== current) {
					target.notifySubscribers(valueToWrite);
				}
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		return result;
	};

	// ensure value is greater than or equal to minValue
	x.min = function (target, minValue) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				var current = target(), valueToWrite = isNaN(newValue) || newValue < minValue ? minValue : newValue;
				if (valueToWrite !== current) target(valueToWrite);
				else {
					if (newValue !== current) {
						if (newValue === null || newValue === '') { target.notifySubscribers(null); return; }
						else target.notifySubscribers(valueToWrite);
					}
				}
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.min = minValue;
		return result;
	};

	// ensure value is less than or equal to maxValue
	x.max = function (target, maxValue) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				var current = target(), valueToWrite = isNaN(newValue) || newValue > maxValue ? maxValue : newValue;
				if (valueToWrite !== current) target(valueToWrite);
				else {
					if (newValue !== current) {
						if (newValue === null || newValue === '') { target.notifySubscribers(null); return; }
						else target.notifySubscribers(valueToWrite);
					}
				}
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.max = maxValue;
		return result;
	};

	// ensure value is a boolean
	x.boolean = function (target, defaultValue) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				if (newValue === null || newValue === void 0 || newValue === '') { target(defaultValue); return; }
				var current = target(), newValueAsBool = defaultValue;
				if (typeof (newValue) === 'boolean') { target(newValue); return; }
				else { newValueAsBool = newValue == 1 || newValue == 'true'; }
				if (newValueAsBool !== current) target(newValueAsBool);
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.boolean = defaultValue;
		return result;
	};

	// ensure value is numeric and round according to decimal precision
	x.money = function (target) {
		var result = x.numeric(target, 2);
		result('$' + target());
		result.extended = result.extended || new Extended(target);
		result.extended.money = 0;
		return result;
	};

	// ensure value is numeric and round according to decimal precision
	x.percentage = function (target) {
		var result = x.numeric(target, 0);
		result(target() + '%');
		result.extended = result.extended || new Extended(target);
		result.extended.percentage = 0;
		return result;
	};

	// ensure value is array and make observables from it elements
	x.makeObservable = function (target, template) {
		var result = ko.computed({
			read: target,
			write: function (newValue) {
				if (newValue === null || !Array.isArray(newValue)) { target(null); return; }
				var current = target(), valueToWrite = ko.utils.makeObservable(template, newValue);
				if (valueToWrite !== current) target(valueToWrite);
				else {
					if (newValue !== current) {
						if (newValue === null || newValue === '') { target.notifySubscribers(null); return; }
						else target.notifySubscribers(valueToWrite);
					}
				}
			}
		}).extend({ notify: 'always' });
		result(target());
		result.extended = result.extended || new Extended(target);
		result.extended.makeObservable = template;
		return result;
	};
})(ko.extenders);